import { Injectable, signal } from '@angular/core';
import { ICommonTableConfig, ICommonTableService } from '@lib-ui/common-table/models/common-table.interface';
import { BehaviorSubject } from 'rxjs';
import { CommonTableData } from '@lib-ui/common-table/models/common-table-data.class';
import { MessageService } from '@lib-services/message.service';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '@lib-typing/response.interface';
import { ICustomFieldsConfig, ICustomFieldsTableData } from '@lib-typing/custom-fields-config.interface';
import { CustomFieldsService } from '@lib-services/custom-fields.service';

@Injectable({
    providedIn: 'root',
})
export class CustomFieldsTableService implements ICommonTableService<ICustomFieldsTableData> {
    public tableData$: BehaviorSubject<CommonTableData<ICustomFieldsTableData>> = new BehaviorSubject<CommonTableData<ICustomFieldsTableData>>(new CommonTableData());
    defaultFilterParams = {
        sortBy: 'createdAt:DESC',
    };
    private readonly commonTableData = new CommonTableData();
    loading = signal<boolean>(false);

    constructor(private customFieldsService: CustomFieldsService, private messageService: MessageService) {}

    updateData(config: ICommonTableConfig): void {
        this.loading.set(true);
        this.customFieldsService
            .getCustomFieldsConfigs(this.createSearchParams(config))
            .subscribe({
                next: response => {
                    this.tableData$.next(new CommonTableData({...response, data: response.data.map(config => config.tableData())}));
                },
                error: () => this.messageService.errorMessage('Ошибка загрузки списка компаний'),
            })
            .add(() => this.loading.set(false));
    }

    createSearchParams(config: ICommonTableConfig): Params {
        this.commonTableData.data.length = 0;
        const { pageIndex, itemsPerPage } = config.paginatorConfig;
        const { filters } = config;

        let searchParams: Params = {
            ...this.defaultFilterParams,
            limit: itemsPerPage.toString(),
        };

        if (pageIndex) {
            searchParams = {
                ...searchParams,
                page: pageIndex.toString(),
            };
        }

        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value) {
                    let filterValue;

                    switch (key) {
                    case 'name':
                        filterValue = `$ilike:${value}`;
                        break;
                    default:
                        filterValue = `${value}`;
                    }
                    searchParams = {
                        ...searchParams,
                        [`filter.${key}`]: filterValue,
                    };
                }
            });
        }

        return searchParams;
    }
}
